const register = {
  loginCredentials: "Anmeldedaten", // translated
  companyInformation: "Firmeninformation", // translated
  contactDetails: "Kontaktdetails", // translated
  businessName: "Firmenname", // translated
  businessAddress: "Geschäftsadresse", // translated
  registrationCode: "Registrierungscode", // translated
  businessRegistrationNumber: "Handelsregisternummer", // translated
  websiteUrl: "Webadresse", // translated
  mobilePhone: "Mobiltelefon", // translated
  regionStateProvince: "Region/Bundesland/Provinz", // translated
  legalTitle: "Legaler Titel", // translated
  city: "Stadt", // translated
  postalCode: "Postleitzahl", // translated
  registrationSuccess: "Registrierung erfolgreich.", // translated
  pleaseWaitFewMomentsAndYouWillBeRedirectedToHome:
    "Bitte warten Sie einen Moment und Sie werden zur Startseite weitergeleitet.", // translated
  usernameEmail: "Benutzername (E-Mail)", // translated
  password: "Passwort", // translated
  verifyPassword: "Passwort bestätigen", // translated
  documents: "Dokumente", // translated
  termsAndConditionsSection: "Allgemeine Geschäftsbedingungen", // translated
  certificateOfIncorporation: "Gründungsurkunde", // translated
  acceptTermsAndConditions: "Allgemeine Geschäftsbedingungen akzeptieren", // translated
  country: "Land", // translated
  brandName: "Markenname", // translated
  register: "Registrieren", // translated
  isRequired: "Ist erforderlich", // translated
  passwordMin8Chars: "Muss mindestens 8 Zeichen haben", // translated
  passwordRequiresDigit: "Muss mindestens 1 Ziffer enthalten", // translated
  passwordRequiresLowercase: "Muss mindestens 1 Kleinbuchstaben enthalten", // translated
  passwordRequiresUppercase: "Muss mindestens 1 Großbuchstaben enthalten", // translated
  passwordRequiresSpecialChar: 'Muss mindestens 1 Sonderzeichen enthalten (!@#$%^&*(),.?":{}|<>)', // translated
  uploadFile: "Datei hochladen", // translated
  filename: "Dateiname:", // translated
  fileType: "Typ:", // translated
  fileSize: "Größe:", // translated
  maxFileSize10Mb: "Max.: 10 MB", // translated
  supportedFileTypes: "Unterstützte Dateitypen:", // translated
  showPassword: "Passwort anzeigen", // translated
  hidePassword: "Passwort ausblenden", // translated
  notAvailable: "N/V", // translated
  fileSizeInKb: "{{size}} KB", // translated
  mobilePhonePlaceholder: "z. B. +4915123456789", // translated
  websiteUrlPlaceholder: "http://www.beispiel.de", // translated
  loading: "Wird geladen...", // translated
  uploadingDocument: "Dokument wird hochgeladen...", // translated
  percentUploaded: "{{percent}}% hochgeladen", // translated
  registrationSuccessful: "Registrierung erfolgreich.", // translated
  failedToUploadDocument: "Dokument konnte nicht hochgeladen werden.", // translated
  fieldIsRequired: "{{field}} {{isRequired}}", // translated
  fieldMinLength: "{{field}} muss länger als {{min}} Zeichen sein", // translated
  fieldMustBeValidEmail: "{{field}} muss eine gültige E-Mail sein", // translated
  fieldPasswordMinLength: "{{field}} muss mindestens 8 Zeichen haben", // translated
  fieldPasswordRequiresDigit: "{{field}} muss mindestens 1 Ziffer enthalten", // translated
  fieldPasswordRequiresLowercase: "{{field}} muss mindestens 1 Kleinbuchstaben enthalten", // translated
  fieldPasswordRequiresUppercase: "{{field}} muss mindestens 1 Großbuchstaben enthalten", // translated
  fieldPasswordRequiresSpecialChar:
    '{{field}} muss mindestens 1 Sonderzeichen enthalten (!@#$%^&*(),.?":{}|<>)', // translated
  passwordsDoNotMatch: "{{field}} stimmt nicht mit {{otherField}} überein", // translated
  fieldBetweenLength: "{{field}} muss zwischen {{min}} und {{max}} Zeichen lang sein", // translated
  postalCodeBetweenLength: "{{field}} muss zwischen {{min}} und {{max}} Zeichen lang sein", // translated
  invalidUrlFormat: "Ungültiges URL-Format", // translated
  invalidEmailFormat: "Ungültiges E-Mail-Format", // translated
  emailMustMatchUsername: "E-Mail muss mit dem Benutzernamen (E-Mail) übereinstimmen", // translated
  mobilePhoneIsRequired: "Mobiltelefon ist erforderlich", // translated
  certificateFileTooLarge: "Gründungsurkunde ist zu groß", // translated
  termsMustBeAccepted: "Allgemeine Geschäftsbedingungen müssen akzeptiert werden", // translated
};


export default register;
